import { Category, SearchCategory, VATCategory } from '@/models/service.model'
import axios from 'axios'
import { ComputedRef } from 'vue'
import { useQuery } from 'vue-query'
import i18n from '../i18n'

// https://tkdodo.eu/blog/effective-react-query-keys
const categoryKeys = {
  all: ['categories'] as const,
  lists: () => [...categoryKeys.all, 'list'] as const,
  list: (locale: ComputedRef<string>) =>
    [...categoryKeys.lists(), { locale }] as const,

  searchCategories: ['searchCategories'] as const,
  searchList: (locale: ComputedRef<string>) =>
    [...categoryKeys.searchCategories, { locale }] as const,
  vatCategories: ['vatCategories'] as const,
  vatList: (locale: ComputedRef<string>) =>
    [...categoryKeys.vatCategories, { locale }] as const,
}

export function useCategoryQuery() {
  const localeRef: any = i18n.global.locale
  return useQuery(categoryKeys.list(localeRef), fetchServiceCategories, {
    staleTime: 1000 * 60 * 60 * 8,
    retry: 0,
  })
}

export function useSearchCategoryQuery() {
  const localeRef: any = i18n.global.locale
  return useQuery(categoryKeys.searchList(localeRef), fetchSearchCategories, {
    staleTime: 1000 * 60 * 60 * 8,
    retry: 0,
  })
}

export function useVatCategoryQuery() {
  const localeRef: any = i18n.global.locale
  return useQuery(categoryKeys.vatList(localeRef), fetchVATCategories, {
    staleTime: 1000 * 60 * 60 * 8,
    retry: 0,
  })
}

export async function fetchServiceCategories(): Promise<Category[]> {
  const { data } = await axios.get<Category[]>('categories/')
  return data
}

export async function fetchVATCategories(): Promise<VATCategory[]> {
  const { data } = await axios.get<VATCategory[]>('vat-categories/')
  return data
}

export async function fetchSearchCategories(): Promise<SearchCategory[]> {
  const { data } = await axios.get<SearchCategory[]>(
    'public/search-categories/',
  )
  return data
}
